var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExerciseReading = function SvgExerciseReading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#exercise-reading_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.273 4.415C1 6.167 1 8.667 1 13.667v2.666c0 5 0 7.5 1.273 9.252a6.7 6.7 0 0 0 1.475 1.475C5.501 28.333 8 28.333 13 28.333s7.5 0 9.252-1.273a6.7 6.7 0 0 0 1.475-1.475C25 23.833 25 21.333 25 16.333v-2.666c0-5 0-7.5-1.273-9.252a6.7 6.7 0 0 0-1.475-1.475C20.5 1.667 18 1.667 13 1.667s-7.5 0-9.252 1.273a6.7 6.7 0 0 0-1.475 1.475",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#exercise-reading_svg__b)",
    strokeLinecap: "round",
    d: "M1.869 4.12C1.159 5.098.826 6.259.662 7.77.5 9.264.5 11.161.5 13.634v2.73c0 2.473 0 4.37.162 5.866.164 1.511.498 2.672 1.207 3.648l.404-.294-.404.294a7.2 7.2 0 0 0 1.585 1.586c.976.709 2.137 1.043 3.648 1.206 1.496.162 3.393.162 5.867.162h.062c2.474 0 4.37 0 5.867-.162 1.511-.163 2.672-.497 3.648-1.206a7.2 7.2 0 0 0 1.585-1.586c.71-.976 1.043-2.137 1.207-3.648.162-1.496.162-3.393.162-5.866v-2.73c0-2.473 0-4.37-.162-5.866-.164-1.511-.498-2.672-1.207-3.648a7.2 7.2 0 0 0-1.585-1.586c-.976-.708-2.137-1.043-3.648-1.206-1.496-.162-3.393-.162-5.867-.162h-.062c-2.474 0-4.37 0-5.867.162-1.511.163-2.672.498-3.648 1.206A7.2 7.2 0 0 0 1.87 4.121Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#exercise-reading_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#exercise-reading_svg__d)",
    fillRule: "evenodd",
    d: "M7.667 8.667a1 1 0 1 0 0 2h10.666a1 1 0 1 0 0-2zm0 5.333a1 1 0 1 0 0 2h10.666a1 1 0 1 0 0-2zm0 5.333a1 1 0 1 0 0 2h10.666a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "exercise-reading_svg__b",
    x1: 1,
    x2: 27.53,
    y1: 1.667,
    y2: 25.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exercise-reading_svg__d",
    x1: 13.107,
    x2: 30.589,
    y1: 24.032,
    y2: 6.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exercise-reading_svg__a",
    width: 74,
    height: 76.667,
    x: -24,
    y: -23.333,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_725_5112"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_725_5112",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exercise-reading_svg__c",
    width: 60.667,
    height: 60.667,
    x: -17.333,
    y: -15.333,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_725_5112"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_725_5112",
    result: "shape"
  })))));
};
export { SvgExerciseReading as ReactComponent };